<template>
  <div class="conference">
    <div class="left wow fadeInLeft">
      <div class="big-title"><img src="https://static.worldaic.com.cn/2024/web/static/images/c.png" alt="">onference 大会</div>
      <div class="zhibo">
        <img class="fengmian" v-if="(!firstRow || !firstRow.coverImgUrl) && isPc" src="https://static.worldaic.com.cn/2024/web/static/images/default-dahui.jpg" alt="">
        <img class="fengmian" v-if="(!firstRow || !firstRow.coverImgUrl) && !isPc" src="https://static.worldaic.com.cn/2024/web/static/images/default-dahui-wap.jpg" alt="">
        <img class="fengmian" v-if="firstRow.coverImgUrl" :src="firstRow.coverImgUrl" alt="">
        <div class="mask" v-if="firstRow.coverImgUrl && firstRow.playSts == 1">
          <img src="https://static.worldaic.com.cn/2024/web/static/images/play-icon.png" alt="">
          <p>点击进入直播</p>
        </div>
      </div>
    </div>
    <div class="right wow fadeInRight">
      <!-- <div class="tabs" :class="'active' + activeIndex" v-if="dates && dates.length">
        <div class="tab" :class="{ active: activeIndex === index }" @click="tabFn(index)" v-for="(item, index) in dates" :key="index">{{ item }}</div>
      </div> -->
      <waic-tabs jc="left" padding="0 .2rem" pl=".8rem" width="auto" :data="dates" @click="tabFn" :active="activeIndex"></waic-tabs>
      <ul>
        <li v-for="(item, index) in data" :key="index" @click="showForum(item, index)">
          <div class="item-left">
            <big v-html="turnNum(`${item.startTime}-${item.endTime}`)"></big>
            <small>{{ item['typeValue' + En] }}</small>
          </div>
          <div class="item-mid">
            <big>{{ item['name' + En] }}</big>
            <small><img src="https://static.worldaic.com.cn/2024/web/static/images/addr.png" alt=""> {{ item['addr' + En] }}</small>
          </div>
          <div class="item-right" :class="En ? 'item-right-en' : ''" v-if="playSts(item.playSts)">
            <p>
              <img v-if="item.playSts == 1" src="https://static.worldaic.com.cn/2024/web/static/images/zhibo-active.png" alt="">
              <img v-else src="https://static.worldaic.com.cn/2024/web/static/images/zhibo.png" alt="">
              <span class="pc">{{ playSts(item.playSts) }}</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="learn">
      <span @click="$router.push('/forum')">
        <img v-if="En" class="pub-learn" src="https://static.worldaic.com.cn/2024/web/static/images/learnEn.png" alt="">
        <img v-else class="pub-learn" src="https://static.worldaic.com.cn/2024/web/static/images/learn.png" alt="">
      </span>
    </div>
    <meetDialog
      :showMeetModal.sync="showMeetModal"
      :uuid.sync="uuid"
    ></meetDialog>
  </div>
</template>

<script>
import protal from "@/api/protal";
import meetDialog from "@/components/meetDialog.vue";

export default {
  components: {
    meetDialog
  },
  name: 'Conference',
  props: {
    dateList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      dates: [],
      activeIndex: 0,
      data: [],
      firstRow: {},
      showMeetModal: false,
      uuid: ''
    }
  },
  watch: {
    dateList(v) {
      this.dates = v.map(x => x.date)
      this.getData()
    },
  },
  methods: {
    tabFn(index) {
      this.activeIndex = index
      this.getData()
    },
    getData() {
      let params = {
        forumTime: [this.dateList[this.activeIndex].timeId],
        yearUuid: this.dateList[this.activeIndex].yearUuid,
        pageNum: 1,
        pageSize: 20,
        queryLocation: "home"
      };
      protal.queryForumList(params).then((res) => {
        if (res && res.data) {
          if (res.data[0].recommendSts == 0) {
            this.firstRow = res.data[0]
            res.data.shift()
          } else {
            this.firstRow = {}
          }
          this.data = res.data
        }
      });
    },
    async showForum(item, index) {
      // console.log(item.dataTagRes, '标签')
      // let arr = item.dataTagRes || []
      // arr = arr.map(x => x.dataTag)
      // let industryFirstCate_var = this.labels.filter(x => arr.includes(x.uuid)).map(x => x.lableDesc).join('|')
      this.$jsAPI('track','homeClick',
          {
            'floor_var': 'Conference大会',
            'position_var': `${ this.activeIndex + 1 }-${ index + 1 }`,
            'flowName_var': item.name,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryFirstCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industrySecCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': this.dates[this.activeIndex],
          }
      );
      gio('track','homeClick',
          {
            'floor_var': 'Conference大会',
            'position_var': `${ this.activeIndex + 1 }-${ index + 1 }`,
            'flowName_var': item.name,
            // 'industryFirstCate_var': industryFirstCate_var ? '|' + industryFirstCate_var + '|' : '无',
            // 'industrySecCate_var': '无',
            'industryCate_var': this.getFirstLabel(item.dataTagTwoRes),
            'industryFirstCate_var': await this.getSecLabel(item.dataTagTwoRes),
            'tabName_var': this.dates[this.activeIndex],
          }
      );
      this.showMeetModal = true
      this.uuid = item.uuid
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .conference {
    position: relative;
    width: 100%;
    height: 9.2rem;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/conference-bg.jpg");
    background-size: cover;
    padding: 0 1.1rem;
    display: flex;
    justify-content: space-between;
    text-align: left;
  }

  .left {
    padding-top: .46rem;
    flex: 0 0 5.2rem;

    .zhibo {
      position: relative;
      margin-top: 1rem;
      width: 5.2rem;
      height: 5.85rem;
      border-radius: .16rem;
      overflow: hidden;

      .fengmian {
        width: 100%;
        height: 100%;
      }

      .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          cursor: pointer;
          width: 1rem;
          height: auto;
        }

        p {
          font-size: .2rem;
          font-weight: 400;
          color: #FFFFFF;
          margin-top: .27rem;
          line-height: 1;
          cursor: pointer;
        }
      }
    }
  }

  .right {
    flex: 0 0 11.4rem;
    overflow: hidden;
    padding-top: 1.39rem;

    ul {
      height: 6.2rem;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      li {
        position: relative;
        display: flex;
        padding: .31rem .32rem .28rem .26rem;
        border-bottom: 1px solid #B4B4B5;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
        }

        .item-left {
          flex: 0 0 2.25rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          overflow: hidden;

          big {
            display: block;
            font-size: .32rem;
            font-weight: 300;
            color: #595757;
            line-height: .32rem;
          }

          small {
            display: block;
            font-size: .18rem;
            font-weight: 400;
            color: #595757;
            line-height: 1;
          }
        }

        .item-mid {
          flex: 1;
          overflow: hidden;
          margin-top: -0.05rem;
          margin-right: 1.4rem;

          big {
            font-family: sybold;
            font-size: .26rem;
            font-weight: normal;
            color: #595757;
            line-height: .36rem;
          }

          small {
            display: flex;
            align-items: center;
            font-size: .18rem;
            color: #595757;
            line-height: 1;
            margin-top: .14rem;

            img {
              width: .2rem;
              height: .2rem;
            }
          }
        }

        .item-right {
          position: absolute;
          left: calc(100% - 1.4rem);

          &.item-right-en {
            left: calc(100% - 1.6rem);
          }
          
          p {
            width: 100%;
            display: flex;
            text-align: left;
            font-size: .18rem;
            font-weight: 400;
            color: #727171;
            line-height: .2rem;
            height: .2rem;
            cursor: pointer;
            white-space: nowrap;

            img {
              width: auto;
              height: .2rem;
              margin-right: .08rem;
            }
          }
        }
      }
    }
  }

  .learn {
    position: absolute;
    bottom: .48rem;
    font-size: .18rem;
    font-weight: 400;
    color: #595757;
    line-height: .3rem;
    right: 1.4rem;
    
    span {
      cursor: pointer;
    }
  }

}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .conference {
    position: relative;
    width: 100%;
    background: url("https://static.worldaic.com.cn/2024/web/static/images/conference-bg-wap.jpg");
    background-size: 100% 100%;
    padding: 0 .32rem;
  }

  .left {
    padding-top: .4rem;
    flex: 0 0 5.2rem;

    .zhibo {
      position: relative;
      margin-top: .72rem;
      width: 100%;
      height: 3.86rem;
      border-radius: .16rem;
      overflow: hidden;
      
      .fengmian {
        width: 100%;
        height: 100%;
      }

      .mask {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        img {
          cursor: pointer;
          width: 1rem;
          height: auto;
        }

        p {
          font-size: .2rem;
          font-weight: 400;
          color: #FFFFFF;
          margin-top: .27rem;
          line-height: 1;
          cursor: pointer;
        }
      }
    }
  }

  .right {
    width: 100%;
    overflow: hidden;
    padding-top: .57rem;

    ul {
      margin-top: .28rem;
      height: 7.1rem;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      li {
        display: flex;
        padding: .3rem 0;
        border-bottom: 1px solid #B4B4B5;

        &:last-child {
          border-bottom: none;
        }

        .item-left {
          width: 1.8rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          big {
            display: block;
            font-weight: 300;
            color: #595757;
            line-height: .3rem;
          }

          small {
            display: block;
            font-size: .22rem;
            font-weight: 400;
            color: #595757;
            line-height: 1;
          }
        }

        .item-mid {
          width: 4rem;
          overflow: hidden;
          margin-top: -0.04rem;

          big {
            font-family: sybold;
            font-size: .26rem;
            color: #595757;
            line-height: .36rem;
          }

          small {
            display: flex;
            align-items: center;
            font-size: .24rem;
            color: #595757;
            line-height: 1;
            margin-top: .2rem;

            img {
              width: .22rem;
              height: auto;
            }
          }
        }

        .item-right {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          margin-top: -0.02rem;
          
          p {
            display: flex;
            align-items: center;
            text-align: right;
            font-size: .24rem;
            font-weight: 400;
            color: #727171;
            line-height: .36rem;
            height: .36rem;
            cursor: pointer;

            img {
              width: auto;
              height: .24rem;
              margin-right: .08rem;
            }
          }
        }
      }
    }
  }

  .learn {
    text-align: right;
    font-size: .22rem;
    font-weight: 400;
    color: #595757;
    line-height: .3rem;
    margin-top: .12rem;
    margin-right: .1rem;
    
    span {
      cursor: pointer;
    }
  }
    
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/conference.vue